import React from "react";
import "../../CSS/NewOnboading/OnboadingShimmer.css";

export default function OnboadingShimmer() {
  return (
    <div>
      <div className="shimmer-container">
        {/* Progress header */}
        <div className="shimmer-header">
          <div className="shimmer-step-text"></div>
          <div className="shimmer-complete-text"></div>
        </div>
        <div className="shimmer-progress-bar">
          <div className="shimmer-progress-fill"></div>
        </div>

        {/* Main content */}
        <div className="shimmer-title"></div>
        <div className="shimmer-description"></div>
        <div className="shimmer-description"></div>

        {/* Review platforms button */}
        <div className="shimmer-button-large"></div>

        {/* Platform grid */}
        <div className="shimmer-platforms-grid">
          <div className="shimmer-platform-item"></div>
          <div className="shimmer-platform-item"></div>
          <div className="shimmer-platform-item"></div>
          <div className="shimmer-platform-item"></div>
        </div>
        <div className="shimmer-platforms-grid">
          <div className="shimmer-platform-item"></div>
          <div className="shimmer-platform-item"></div>
          <div className="shimmer-platform-item"></div>
          <div className="shimmer-platform-item"></div>
        </div>

        {/* Footer text */}
        <div className="shimmer-footer-text"></div>

        {/* Navigation buttons */}
        <div className="shimmer-navigation">
          <div className="shimmer-back-button"></div>
          <div className="shimmer-next-button"></div>
        </div>
      </div>
    </div>
  );
}
